// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index_container__2k1C0wsQ,.index_viewport__2k1C0wsQ{width:100%;height:100%;position:relative}.index_viewport__2k1C0wsQ{touch-action:pan-y}.index_room__2k1C0wsQ{border:1px dashed #ccc;height:300px}.index_zoomable-content__2k1C0wsQ{transform-origin:top}", ""]);
// Exports
exports.locals = {
	"container": "index_container__2k1C0wsQ",
	"viewport": "index_viewport__2k1C0wsQ",
	"room": "index_room__2k1C0wsQ",
	"zoomable-content": "index_zoomable-content__2k1C0wsQ"
};
module.exports = exports;
